import database from './../images/database.png';

const Database = () => {
    return (
      <div>
      <p className="standard-paragraph">
      <div class="container">
        <div class="image-container">
        <img src={database} alt="Database" width={300}/>
        </div>
        <div class="text-container">
          <h2>Databases</h2> 
          <p class="text-text">  
            Elevate your data management strategy with our AWS database services. We specialize in designing and optimizing scalable, 
            high-performance databases on AWS, ensuring secure and efficient data storage. As part of our comprehensive software 
            development services, we offer tailored solutions for AWS databases, providing end-to-end support for designing, 
            implementing, and maintaining robust data infrastructure.
          </p>
        </div>
      </div>

      <ul class="custom-list">
        <li><strong>Amazon RDS (Relational Database Service):</strong> Managed relational databases with support for MySQL, PostgreSQL, SQL Server, MariaDB, and Oracle.</li>
        <li><strong>Amazon DynamoDB:</strong> A fully managed NoSQL database for fast and flexible data storage and retrieval.</li>
        <li><strong>Amazon Aurora:</strong> A high-performance, fully managed relational database compatible with MySQL and PostgreSQL.</li>
        <li><strong>Amazon Redshift:</strong> A fully managed data warehousing service for analytics and reporting.</li>
        <li><strong>Amazon Neptune:</strong> A fully managed graph database service for building applications with highly connected data.</li>
        <li><strong>Amazon ElastiCache:</strong> A managed in-memory cache service that supports Redis and Memcached.</li>
        <li><strong>Amazon DocumentDB (with MongoDB compatibility):</strong> A managed document database for applications that use MongoDB.</li>
        <li><strong>Amazon Timestream:</strong> A fully managed time-series database for IoT and operational applications.</li>
        <li><strong>Amazon Keyspaces (for Apache Cassandra):</strong> A serverless, scalable, and highly available NoSQL database service compatible with Apache Cassandra.</li>
        <li><strong>Amazon RDS Proxy:</strong> A fully managed database proxy service for optimizing database performance and scalability.</li>
        <li><strong>Amazon RDS Read Replicas:</strong> Create read replicas of RDS databases to offload read traffic and improve performance.</li>
        <li><strong>Amazon DMS (Database Migration Service):</strong> Migrate your on-premises databases to AWS or replicate data between databases.</li>
    </ul>
    </p>
    </div>
    )
  };
  
  export default Database;